/** IXD 값 편집기 - 업로드 페이지 */

import { EditorUploadView } from "./editor-upload-view";

export const IxdEditorPage = () => <EditorUploadView />;
